/** Accesso staff ad AFFIDYA Family — abilitato dal super-admin per utente (default off). */
export function canAccessFamily(user) {
  if (!user) return false;
  return Boolean(user.family_enabled);
}
